let subscriberSelect = null
let sendToAllChangeHandler = null

function destroyTomSelect(selectEl) {
  if (subscriberSelect) {
    subscriberSelect.destroy()
    subscriberSelect = null
  }

  if (selectEl?.tomselect) {
    selectEl.tomselect.destroy()
    subscriberSelect = null
  }
}

function createTomSelect(selectEl) {
  const TomSelect = window.TomSelect
  if (!TomSelect || subscriberSelect) return subscriberSelect

  subscriberSelect = new TomSelect(selectEl, {
    plugins: ['remove_button'],
    maxItems: null,
    placeholder: selectEl.dataset.placeholder,
    hideSelected: true,
    closeAfterSelect: false
  })

  return subscriberSelect
}

function syncSendToAllState(sendToAllEl, selectEl, containerEl) {
  if (sendToAllEl.checked) {
    subscriberSelect?.clear()
    containerEl.classList.add('d-none')
  } else {
    containerEl.classList.remove('d-none')
    createTomSelect(selectEl)
  }
}

function initSubscriberMultiselect() {
  if (!window.TomSelect) return

  const selectEl = document.getElementById('subscriber_ids')
  const sendToAllEl = document.getElementById('send_to_all')
  const containerEl = document.getElementById('subscriber_ids_container')

  if (!selectEl || !sendToAllEl || !containerEl) return

  if (sendToAllChangeHandler) {
    sendToAllEl.removeEventListener('change', sendToAllChangeHandler)
    sendToAllChangeHandler = null
  }

  destroyTomSelect(selectEl)

  sendToAllChangeHandler = () => {
    syncSendToAllState(sendToAllEl, selectEl, containerEl)
  }
  sendToAllEl.addEventListener('change', sendToAllChangeHandler)

  syncSendToAllState(sendToAllEl, selectEl, containerEl)
}

function destroySubscriberMultiselect() {
  const sendToAllEl = document.getElementById('send_to_all')

  if (sendToAllEl && sendToAllChangeHandler) {
    sendToAllEl.removeEventListener('change', sendToAllChangeHandler)
    sendToAllChangeHandler = null
  }

  destroyTomSelect(document.getElementById('subscriber_ids'))
}

document.addEventListener('turbolinks:load', initSubscriberMultiselect)
document.addEventListener('turbolinks:before-cache', destroySubscriberMultiselect)
